<template>
	<v-btn v-if="!isAnon && (item.isGroup || item.isTag || item.isUser)"
		   :small="small"
		   :x-small="xSmall"
		   icon
		   class="context-menu-btn"
		   @click="onClick">
		<v-icon :small="small" :x-small="xSmall">{{ icon }}</v-icon>
	</v-btn>
</template>

<script>
import base from "@/mixins/base";

export default {
	name: "context-menu-btn",
	props: {
		item: {},
		small: {
			type: Boolean,
			default: false
		},
		xSmall: {
			type: Boolean,
			default: false
		},
	},
	mixins: [base],
	data: () => ({}),
	computed: {
		icon() {
			return this.ui.contextMenu.isVisible && this.ui.contextMenu.item?.id === this.item.id ? "mdi-close" : "mdi-dots-horizontal";
		},
	},
	watch: {},
	methods: {
		onClick(event) {
			event.preventDefault();

			this.$store.dispatch("ui/contextMenu", {
				event,
				item: this.item,
			});
		},
	},
}
</script>

<style lang="scss">
.context-menu-btn {
}
</style>